import React from "react";
import { Link } from 'react-router-dom';

function ScenarioGenerator() {
  return (
    <div>
      <h3><b>Let's pick.</b></h3>
      play games for points!
      <br></br>
      <br></br>
      <Link to="/scenario1">
      <button className="nav-button">Ten Questions</button>
      </Link>
      <br></br>
      <br></br>
      <Link to="/scenario2">
      <button className="nav-button">Real Exams</button>
      </Link>
      <br></br>
      <br></br>
      <Link to="/scenario2">
      <button className="nav-button">Dress Up</button>
      </Link>
    </div>
  );
}

export default ScenarioGenerator;
